/**
 * This sets defaults and handles maintaining our auth token/params
 * between http requests.
 */

import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource);

const lectureNote = Vue.resource('lecture_notes{/id}', {}, {}, { emulateJSON: true, timeout:99999999 }); // emulateJSON so that the pdf file gets passed correctly

export default lectureNote;



// WEBPACK FOOTER //
// ./src/resources/lectureNote.js